import React, { useEffect, useState } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import NotificationBadge from '~/components/NotificationBadge';

import General from './Statistics/General';
import Status from './Statistics/Status';
import Prices from './Statistics/Prices';
import Procedures from './Statistics/Procedures';
import Rebate from './Statistics/Rebate';
import PendingProjects from './PendingProjects';

import { useAuth } from '~/hooks/auth';

import api from '~/services/api';

import { Container, TabTitle, TabFirst, TabSecond, TabThird } from './styles';

import { VALID_STAT_USER_TYPES } from '../constants';

export interface IProject {
  type: string;
  code?: string;
  display?: {
    name?: string;
  };
  material?: {
    name?: string;
  };
  sponsorship?: {
    name?: string;
  };
  adversity?: {
    name?: string;
  };
  folder?: {
    name?: string;
  };
  sample?: {
    name?: string;
  };
  event?: {
    name?: string;
  };
  local_client: {
    company_name: string;
  };
  project_procedure: {
    sequence: number;
    description: string;
    extra_validation: boolean;
  };
}

const MainContent: React.FC = () => {
  const { user } = useAuth();
  const [tabIndex, setTabIndex] = useState(0);
  const [projects, setProjects] = useState<IProject[]>([]);

  useEffect(() => {
    api.get(`/projects/usertypependingprojects`).then(response => {
      setProjects(response.data);
    });
  }, []);

  const handleGeneralStatisticsTabList = (): React.ReactNode => {
    return (
      <Tab>
        <TabTitle>Geral</TabTitle>
      </Tab>
    );
  };

  const handleGeneralStatisticsTabPanel = (): React.ReactNode => {
    return (
      <TabPanel>
        <TabFirst>
          <General />
        </TabFirst>
      </TabPanel>
    );
  };

  const handleStatusStatisticsTabList = (): React.ReactNode => {
    return (
      <Tab>
        <TabTitle>Status</TabTitle>
      </Tab>
    );
  };

  const handleStatusStatisticsTabPanel = (): React.ReactNode => {
    return (
      <TabPanel>
        <TabSecond>
          <Status />
        </TabSecond>
      </TabPanel>
    );
  };

  const handlePriceStatisticsTabList = (): React.ReactNode => {
    if (VALID_STAT_USER_TYPES.includes(user.user_type.type)) {
      return (
        <Tab>
          <TabTitle>Valores</TabTitle>
        </Tab>
      );
    }

    return null;
  };

  const handlePriceStatisticsTabPanel = (): React.ReactNode => {
    if (VALID_STAT_USER_TYPES.includes(user.user_type.type)) {
      return (
        <TabPanel>
          <TabThird>
            <Prices />
          </TabThird>
        </TabPanel>
      );
    }

    return null;
  };

  const handleRebateStatisticsTabList = (): React.ReactNode => {
    if (VALID_STAT_USER_TYPES.includes(user.user_type.type)) {
      return (
        <Tab>
          <TabTitle>Rebate</TabTitle>
        </Tab>
      );
    }

    return null;
  };

  const handleProcedureStatisticsTabList = (): React.ReactNode => {
    if (VALID_STAT_USER_TYPES.includes(user.user_type.type)) {
      return (
        <Tab>
          <TabTitle>Etapas</TabTitle>
        </Tab>
      );
    }

    return null;
  };

  const handleProcedureStatisticsTabPanel = (): React.ReactNode => {
    if (VALID_STAT_USER_TYPES.includes(user.user_type.type)) {
      return (
        <TabPanel>
          <TabThird>
            <Procedures />
          </TabThird>
        </TabPanel>
      );
    }

    return null;
  };

  const handleRebateStatisticsTabPanel = (): React.ReactNode => {
    if (VALID_STAT_USER_TYPES.includes(user.user_type.type)) {
      return (
        <TabPanel>
          <TabThird>
            <Rebate />
          </TabThird>
        </TabPanel>
      );
    }

    return null;
  };

  const handleNotificationsTabList = (): React.ReactNode => {
    return (
      <Tab>
        <TabTitle>
          <div style={{ display: 'flex', columnGap: '5px' }}>
            Notificações
            {projects.length > 0 && (
              <NotificationBadge count={projects.length} />
            )}
          </div>
        </TabTitle>
      </Tab>
    );
  };

  const handleNotificationsTabPanel = (): React.ReactNode => {
    return (
      <TabPanel>
        <TabThird>
          <PendingProjects projects={projects} />
        </TabThird>
      </TabPanel>
    );
  };

  return (
    <Container>
      <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
        <TabList>
          {handleGeneralStatisticsTabList()}
          {handleStatusStatisticsTabList()}
          {handlePriceStatisticsTabList()}
          {handleProcedureStatisticsTabList()}
          {handleRebateStatisticsTabList()}
          {handleNotificationsTabList()}
        </TabList>
        {handleGeneralStatisticsTabPanel()}
        {handleStatusStatisticsTabPanel()}
        {handlePriceStatisticsTabPanel()}
        {handleProcedureStatisticsTabPanel()}
        {handleRebateStatisticsTabPanel()}
        {handleNotificationsTabPanel()}
      </Tabs>
    </Container>
  );
};

export default MainContent;
